<template>
  <v-row
    no-gutters
    class="align-center element justify-space-between flex-nowrap"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
    @click="hideableGroups && isGroup ? $emit('toggleHideGroup') : null"
  >
    <v-col v-if="hideableGroups && isGroup" cols="auto" style="margin-left: -24px;">
      <v-icon>
        {{ isHidden ? 'mdi-menu-right' : 'mdi-menu-down' }}
      </v-icon>
    </v-col>
    <v-col style="min-width: 0;">
      <v-row no-gutters class="flex-nowrap align-center">
        <v-col cols="auto">
          <slot name="item.prepend-title" :item="this.$attrs"></slot>
        </v-col>
        <v-col cols="auto" class="flex-shrink-1" style="min-width: 0">
          <v-tooltip ref="tooltip-test" bottom color="font" :disabled="!tooltip">
            <template #activator="{ on }">
              <div
                ref="title-item"
                v-on="on"
                class="text-truncate text-body-2"
                :class="{ 'pl-2': level > 1, 'text--disabled': disabled }"
                style="padding-top: 2px;"
              >
                {{ title }}
              </div>
            </template>
            {{ tooltip }}
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="auto">
      <dots-menu
        v-if="dotsItems && dotsItems.length"
        :disabled="disabled"
        font-size="19px"
        :items="dotsItems"
        v-on="getListeners()"
      />
    </v-col>
  </v-row>
</template>
<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'DraggableListItem',
  components: { DotsMenu },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hideableGroups: {
      type: Boolean,
      default: false,
    },
    dotsItems: {
      type: Array,
    },
    childItemsKey: {
      type: String,
      default: 'items',
    },
    tooltip: {
      type: String,
      default: null,
    },
    level: {
      type: Number,
      default: 1,
    },
    titleKey: {
      type: String,
      default: 'name',
    },
    isHidden: {
      type: Boolean,
      default: false,
    },
    disableBorders: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.$attrs[this.childItemsKey] ? true : false;
    },
    classes() {
      return this.level > 1
        ? [...(this.isGroup ? [] : [...(this.disableBorders ? [] : ['border']), 'px-4'])]
        : this.isGroup
        ? [this.isHidden ? 'hidden' : '']
        : ['px-6'];
    },
    backgroundColor() {
      return this.isGroup ? 'white' : 'rgb(231, 231, 231, 0.5)';
    },
    title() {
      return this.$attrs[this.titleKey];
    },
  },
  methods: {
    getListeners() {
      return Object.keys(this.$listeners).reduce((total, key) => {
        return {
          ...total,
          [key]: () => {
            this.$emit(key, { ...this.$props, ...this.$attrs });
          },
        };
      }, {});
    },
  },
};
</script>
<style scoped lang="scss">
.element {
  height: 40px;
}
.border {
  margin-bottom: 4px;
  @include border(right);
  @include border(left);
  @include border(bottom);
  &:first-child {
    @include border(top);
  }
}
</style>
